export var BoardEventType;
(function (BoardEventType) {
    BoardEventType["TokenAdded"] = "TokenAdded";
    BoardEventType["TokenMoved"] = "TokenMoved";
    BoardEventType["TokenRemoved"] = "TokenRemoved";
    BoardEventType["DrawingDrawn"] = "DrawingDrawn";
    BoardEventType["DrawingErased"] = "DrawingErased";
    BoardEventType["AllDrawingsErased"] = "AllDrawingsErased";
    BoardEventType["LineDrawn"] = "LineDrawn";
    BoardEventType["LineErased"] = "LineErased";
    BoardEventType["AllLinesErased"] = "AllLinesErased";
    BoardEventType["TextWritten"] = "TextWritten";
    BoardEventType["TextEdited"] = "TextEdited";
    BoardEventType["TextColorChanged"] = "TextColorChanged";
    BoardEventType["TextSizeChanged"] = "TextSizeChanged";
    BoardEventType["TextMoved"] = "TextMoved";
    BoardEventType["TextRemoved"] = "TextRemoved";
    BoardEventType["AllTextsRemoved"] = "AllTextsRemoved";
    BoardEventType["BoardReset"] = "BoardReset";
})(BoardEventType || (BoardEventType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYm9hcmQtZXZlbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvcmUvYm9hcmQvYm9hcmQtZXZlbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU9BLE1BQU0sQ0FBTixJQUFZLGNBa0JYO0FBbEJELFdBQVksY0FBYztJQUN4QiwyQ0FBeUIsQ0FBQTtJQUN6QiwyQ0FBeUIsQ0FBQTtJQUN6QiwrQ0FBNkIsQ0FBQTtJQUM3QiwrQ0FBNkIsQ0FBQTtJQUM3QixpREFBK0IsQ0FBQTtJQUMvQix5REFBdUMsQ0FBQTtJQUN2Qyx5Q0FBdUIsQ0FBQTtJQUN2QiwyQ0FBeUIsQ0FBQTtJQUN6QixtREFBaUMsQ0FBQTtJQUNqQyw2Q0FBMkIsQ0FBQTtJQUMzQiwyQ0FBeUIsQ0FBQTtJQUN6Qix1REFBcUMsQ0FBQTtJQUNyQyxxREFBbUMsQ0FBQTtJQUNuQyx5Q0FBdUIsQ0FBQTtJQUN2Qiw2Q0FBMkIsQ0FBQTtJQUMzQixxREFBbUMsQ0FBQTtJQUNuQywyQ0FBeUIsQ0FBQTtBQUMzQixDQUFDLEVBbEJXLGNBQWMsS0FBZCxjQUFjLFFBa0J6QiJ9